import { render, staticRenderFns } from "./ExtraInput.vue?vue&type=template&id=b3c00f5a&scoped=true"
import script from "./ExtraInput.vue?vue&type=script&lang=js"
export * from "./ExtraInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c00f5a",
  null
  
)

export default component.exports